"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fidenza": {
    "fe0478ca": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "skipSearch": false
    }],
    "cabriolo": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6a436591": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "skipSearch": false
    }],
    "chiusa-viarola": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "27145a37": [{
      "hkey": "b60bdba1",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "coduro": [{
      "hkey": "b60bdba1",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "059e33c8": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "skipSearch": false
    }],
    "cogolonchio": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bbf6032a": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-di-cusignano": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1608ab6": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "skipSearch": false
    }],
    "siccomonte": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e97f7633": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "skipSearch": false
    }],
    "tabiano": [{
      "hkey": "abe3d324",
      "slug": "fidenza",
      "name": "Fidenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;